import { Action } from "redux";
import { ThunkAction } from "redux-thunk";
import { endpoints } from "../Constants/endpoints";
import { IAppState, ApiRequest } from "../../Common";
import { WorkflowOptions } from "../Models/WorkflowOptions";
import { ISetWorkflowErroredPayload } from "./WorkflowActions";
import ResponseHandler from "../../App/ResponseHandler";

interface IWorkflowOptionsAction extends Action {
  type: WorkflowOptionsActionType;
  payload: any;
}

// ARGUMENT TYPES
export interface IGetWorkflowOptionsArguments {}
export interface ISetWorkflowOptionsLoadingArguments {}
export interface ISetWorkflowOptionsErroredArguments {
  errorMessage: string;
  errorCode: number;
}

// PAYLOAD TYPES

export interface IWorkflowOptionsLoadedPayload {
  loadedOptions: WorkflowOptions;
}

export interface ISetWorkflowOptionsLoadingPayload {}

export interface ISetWorkflowOptionsErroredPayload {
  errorMessage: string;
  errorCode: number;
}

// ACTION TYPES

export interface IWorkflowOptionsLoadedAction extends IWorkflowOptionsAction {
  payload: IWorkflowOptionsLoadedPayload;
}

export interface ISetWorkflowOptionsLoadingAction extends IWorkflowOptionsAction {
  payload: ISetWorkflowOptionsLoadingPayload;
}

export interface ISetWorkflowOptionsErroredAction extends IWorkflowOptionsAction {
  payload: ISetWorkflowErroredPayload;
}

// Union of all action types. Please add new actions here ;)
export type WorkflowOptionsAction =
  | IWorkflowOptionsLoadedAction
  | ISetWorkflowOptionsLoadingAction
  | ISetWorkflowOptionsErroredAction;

export enum WorkflowOptionsActionType {
  WORKFLOW_OPTIONS_LOADED = "WORKFLOW_OPTIONS_LOADED",
  WORKFLOW_OPTIONS_SET_LOADING = "WORKFLOW_OPTIONS_SET_LOADING",
  WORKFLOW_OPTIONS_SET_ERRORED = "WORKFLOW_OPTIONS_SET_ERRORED"
}

export const setErrored = (
  args: ISetWorkflowOptionsErroredArguments
): ISetWorkflowOptionsErroredAction => ({
  type: WorkflowOptionsActionType.WORKFLOW_OPTIONS_SET_ERRORED,
  payload: { ...args }
});

export const getWorkflowOptions = (
  args: IGetWorkflowOptionsArguments
): ThunkAction<
  void,
  IAppState,
  {},
  IWorkflowOptionsLoadedAction | ISetWorkflowOptionsErroredAction
> => dispatch => {
  ApiRequest.fromPath(endpoints.options())
    .withAuthHeader()
    .get()
    .then(response => {
      ResponseHandler.handle(
        response,
        result => {
          // this was successful
          dispatch({
            type: WorkflowOptionsActionType.WORKFLOW_OPTIONS_LOADED,
            payload: {
              loadedOptions: result.payload
            }
          });
        },
        result => {
          dispatch(setErrored({ errorCode: response.status, errorMessage: result.error.message }));
        },
        () => {
          dispatch(
            setErrored({
              errorCode: response.status,
              errorMessage: "An unknown error has occurred"
            })
          );
        }
      );
    });
};

export const setLoading = (
  args: ISetWorkflowOptionsLoadingArguments
): ISetWorkflowOptionsLoadingAction => ({
  type: WorkflowOptionsActionType.WORKFLOW_OPTIONS_SET_LOADING,
  payload: { ...args }
});
